import {Config} from "./types/global";

const config = require(process.env.NODE_ENV === 'production' ? './reapit.config.production.json' : './reapit.config.json')

export default config as Config
